import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "btns-block" }
const _hoisted_2 = {
  key: 0,
  class: "docs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompFileIcon = _resolveComponent("CompFileIcon")!
  const _component_ShadowBlock = _resolveComponent("ShadowBlock")!
  const _component_PeopleIcon = _resolveComponent("PeopleIcon")!
  const _component_DocsList = _resolveComponent("DocsList")!
  const _component_ChoosedDocs = _resolveComponent("ChoosedDocs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_ShadowBlock, {
        class: _normalizeClass(["clickable", {checked:_ctx.docsFrom === 'comp'}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toogComp()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CompFileIcon),
          _cache[7] || (_cache[7] = _createTextVNode(" С компютера"))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ShadowBlock, {
        class: _normalizeClass(["clickable", {checked:_ctx.docsFrom === 'client'}]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.docsFrom = 'client';_ctx.clearFiles()})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PeopleIcon),
          _cache[8] || (_cache[8] = _createTextVNode(" Из клиента"))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("input", {
      style: {"display":"none"},
      type: "file",
      multiple: "",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getfiles($event))),
      accept: "application/pdf",
      ref: "finput"
    }, null, 544),
    (_ctx.docsFrom === 'client' && !_ctx.files.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(_component_DocsList, {
            docs: _ctx.clientDocs.value,
            onCheckDoc: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkDocF($event))),
            onResume: _cache[4] || (_cache[4] = ($event: any) => (_ctx.docsFrom = '')),
            onSave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getClientFiles()))
          }, null, 8, ["docs"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.files.value.length)
      ? (_openBlock(), _createBlock(_component_ChoosedDocs, {
          key: 1,
          docs: _ctx.files.value,
          onDeleteItem: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteFile($event)))
        }, null, 8, ["docs"]))
      : _createCommentVNode("", true)
  ], 64))
}